module.exports = __webpack_public_path__ + "img/8market1.570b5874.jpg";